app.controller('BrowseLayoutSelectController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;

    const selectModel = $rootScope.factory.select.getModel(navigationIDs);


    let selectChoiceList = selectModel ? selectModel.choiceList() : null;
    selectChoiceList = selectChoiceList && selectChoiceList.length > 1 ? selectChoiceList : null;

    $scope.select_choice_list = selectChoiceList;


    $scope.show_select_in_list = true; //todo. Figure out if this is always true

    $scope.select_dropdown_txt = ["cabinet_kitchen", "cabinet_bedroom", "solution"].includes(navigationIDs.base_component_id) ? "Change Cabinet Type" : "Change Category";

    $scope.getSelectID = function () {
        return selectModel ? $rootScope.navigation_model.state_ids[selectModel.navigation_pointer] : null;
    }

    function requireChildState() {
        $rootScope.navigation_manager.requireChildState("select");
    }

    requireChildState();

    $scope.$on('browse_navigation_state_change', function () {
        requireChildState();
    });

}])